import { render, staticRenderFns } from "./projectsStatistics.vue?vue&type=template&id=33797d0d"
import script from "./projectsStatistics.vue?vue&type=script&lang=js"
export * from "./projectsStatistics.vue?vue&type=script&lang=js"
import style0 from "./projectsStatistics.vue?vue&type=style&index=0&id=33797d0d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports